import { AppState } from '../../root-reducer';

export const selectBasemap = (state: AppState) => state.basemapDomain.selectedBasemap;
